export const appPowerPoint = "uu7kae";
export default {appPowerPoint};